import { render, staticRenderFns } from "./ElTipasIcon.vue?vue&type=template&id=388d1736&scoped=true&"
import script from "./ElTipasIcon.vue?vue&type=script&lang=js&"
export * from "./ElTipasIcon.vue?vue&type=script&lang=js&"
import style0 from "./ElTipasIcon.vue?vue&type=style&index=0&id=388d1736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388d1736",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VIcon})
